import i18next from "i18next";

export const GetCurrentLanguage = () =>
  i18next.language === "tr" ? "en" : "tr";

export const ChangeLanguage = () => {
  i18next.changeLanguage(i18next.language === "tr" ? "en" : "tr");
};

export const ChangeLanguageWithValue = (value) => {
  i18next.language = value
  i18next.changeLanguage(value);
};

const Translate = (text, i18nKey, option) => {
  var value = i18next.t(i18nKey, option);
  return value;
};

export default Translate;
